import { SubscriptionState } from "~/lib/types";
import { SEND_TO_ADMINS, SEND_TO_DEV } from "~/lib/constants";
import {
	runQueryCommand,
	RIASTABLE,
	runGetCommand,
	getCounter,
	updateDB,
	queryByPK,
} from "./dynamoDB";

import { sendDevEmail, sendEmail } from "./server.email";

export const getUserRecord = async (userId: number, sk: string) => {
	"use server";

	const r = await runGetCommand({
		TableName: RIASTABLE,
		Key: { pk: `USER#${userId}`, sk },
	});

	return { ...r.Item };
};

export const getUserByEmail = async (email: string) => {
	"use server";

	const r = await runQueryCommand({
		TableName: RIASTABLE,
		IndexName: "gsiUserByEmail",
		KeyConditionExpression: "email = :email",
		ExpressionAttributeValues: {
			":email": email,
		},
		ScanIndexForward: false,
	});

	if (r?.items?.length) {
		const user = await queryByPK(r.items[0].pk, r.items[0].sk);
		return user?.[0];
	}

	return null;
};

export const saveRegistration = async data => {
	"use server";

	// Honeypot. A value that is exactly the company name is browser autofill, not a bot,
	// so accept the registration; any other value is treated as a bot and silently dropped.
	const trap = (data?.website ?? data?.companyWebsite ?? "").trim();
	const autofilled = trap !== "" && trap.toLowerCase() === (data?.companyName ?? "").trim().toLowerCase();

	if (trap !== "" && !autofilled) {
		await sendDevEmail("Honeypot registration attempt", JSON.stringify(data));

		return { success: true, entry: data };
	}

	if (autofilled) {
		await sendDevEmail("Honeypot autofilled - registration accepted", JSON.stringify(data));
	}

	const existingUser = await getUserByEmail(data.email);

	if (existingUser) {
		return { success: false, err: "User already exists", add: existingUser };
	}

	const userId = await getCounter("USER");
	if (userId < 1) {
		return { success: false, err: "Error generating userId", add: userId };
	}

	const pk = `USER#${userId}`;
	const sk = `USER#${userId.toString().padStart(7, "0")}`;

	const updates = {
		userId: userId,
		registered: Date.now(),
		recordType: "USER",
		firstName: data.firstName,
		lastName: data.lastName,
		name: `${data.firstName} ${data.lastName}`,
		email: data.email,
		lastLogin: Date.now(),
		memberships: {
			arb: data.ARB,
			cibse: data.CIBSE,
			rias: data.RIAS,
			ciat: data.MCIAT,
			constructionProfessional: data.contructionPro,
		},
		address: {
			company: data.companyName,
			city: data.city,
			county: data.region,
			addr1: data.addr1,
			postcode: data.postcode,
		},
		targetScheme: data.targetScheme,
		role: SubscriptionState.VALIDATING,
		status: SubscriptionState.APPLYING,
	};

	try {
		const r = await updateDB(pk, sk, updates);

		await sendEmail({
			templateName: "application-received",
			props: { userFirst: data.firstName },
			to: data.email,
			bcc: SEND_TO_DEV,
		});

		await sendEmail({
			templateName: "certifier-requiring-verification",
			props: { user: updates },
			to: SEND_TO_ADMINS,
		});

		return { success: true, entry: r };
	} catch (err) {
		console.log("err", err);
	}

	return { success: false, err: "unknown" };
};

